import { render, staticRenderFns } from "./PermissionsList.vue?vue&type=template&id=32dcc7b4&scoped=true"
import script from "./PermissionsList.vue?vue&type=script&lang=js"
export * from "./PermissionsList.vue?vue&type=script&lang=js"
import style0 from "./PermissionsList.vue?vue&type=style&index=0&id=32dcc7b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dcc7b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32dcc7b4')) {
      api.createRecord('32dcc7b4', component.options)
    } else {
      api.reload('32dcc7b4', component.options)
    }
    module.hot.accept("./PermissionsList.vue?vue&type=template&id=32dcc7b4&scoped=true", function () {
      api.rerender('32dcc7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/user/PermissionsList.vue"
export default component.exports